import * as React from "react";
import { FaShoppingBag, FaMotorcycle, FaUtensils, FaCalendarAlt } from "react-icons/fa";
import { PostmatesLogo } from "../icons/logos";
export const OrderIcon = (props) => {
    switch (props.service) {
        case "pickup":
            return React.createElement(FaShoppingBag, null);
        case "delivery":
            switch (props.deliveryProvider) {
                case "postmates":
                    return React.createElement(PostmatesLogo, null);
                default:
                    return React.createElement(FaMotorcycle, null);
            }
        case "dine_in":
            return React.createElement(FaUtensils, null);
        case "table_booking":
            return React.createElement(FaCalendarAlt, null);
        default:
            return React.createElement(FaShoppingBag, null);
    }
};
//# sourceMappingURL=order-icon.js.map